export {
  useLocationsQuery,
  type LocationsQueryParams
} from './use-locations-query';
